import { SxStyles } from '../../../types';
import theme from '../../../theme';
import { getResponsiveSize } from '../../../utils';

export const selectionCardGroupStyles: SxStyles = {
  selectionCardGroup: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    width: getResponsiveSize(169),
    '& .title-container': {
      display: 'flex',
      justifyContent: 'center',
      width: '66%',
      p: 0,
      '& .title': {
        fontFamily: theme.typography.mainFontFamily,
        fontWeight: '400',
        color: theme.palette.mainControls?.subTitleColor,
        fontSize: theme.typography.fs13,
        p: 0,
        pb: getResponsiveSize(10),
        pointerEvents: 'none',
      },
    },

    '& .items-container': {
      display: 'flex',
      flexDirection: 'column',
      gap: getResponsiveSize(10),
      '& .row': {
        display: 'flex',
        gap: getResponsiveSize(10),
        '&.row-1': {
          justifyContent: 'start',
        },
        '&.row-2': {
          justifyContent: 'start',
        },
        '& .card': {
          position: 'relative',
          width: getResponsiveSize(49),
          borderRadius: '10px',
          backgroundColor: theme.palette.mainControls?.inActivegrey,

          '& .desc': {
            position: 'absolute',
            top: '74%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            color: theme.palette.mainControls?.syan,
            fontSize: getResponsiveSize(9),
            pt: getResponsiveSize(4),
            whiteSpace: 'nowrap',
          },
          '& .icon': {
            position: 'absolute',
            top: '35%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            '& svg': {
              fill: theme.palette.neutral?.grey,

              '& path': {
                fill: theme.palette.mainControls?.syan,
              },
              '& .circle': {
                stroke: theme.palette.mainControls?.syan,
                fill: theme.palette.myPrimary?.white,
                transition: theme.palette.propVars?.easeInOutTransition,
                strokeWidth: '2',
              },
            },
          },
          '& .Ellipse': {
            width: getResponsiveSize(55),
            '& svg': {
              transform: 'rotate(180deg)',
              '& .circle': {
                offsetPath:
                  'path("M63.34 13.75C63.34 17.0647 60.3624 20.2289 55.1626 22.5933C50.0078 24.9372 42.8514 26.4 34.92 26.4C26.9886 26.4 19.8322 24.9372 14.6774 22.5933C9.47759 20.2289 6.5 17.0647 6.5 13.75C6.5 10.4353 9.47759 7.27108 14.6774 4.9067C19.8322 2.56282 26.9886 1.1 34.92 1.1C42.8514 1.1 50.0078 2.56282 55.1626 4.9067C60.3624 7.27108 63.34 10.4353 63.34 13.75Z")',
                strokeWidth: '1',
                r: '6.5',
              },
            },
          },
          '&.active': {
            backgroundColor: theme.palette.mainControls?.mainBlue,
            '& .desc': {
              color: theme.palette.neutral?.white,
            },
            '& .icon': {
              '& svg': {
                fill: theme.palette.neutral?.white,
                '& path': {
                  fill: theme.palette.neutral?.white,
                },
              },
            },
            '& .MuiButtonBase-root': {
              '&:before': {
                content: "''",
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                filter: 'blur(2px)',
                border: 'inherit',
                zIndex: '3000',
              },
            },
          },
          '& .MuiButtonBase-root': {
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            p: getResponsiveSize(10),
            height: getResponsiveSize(45.2),
            borderRadius: theme.palette.propVars?.borderRadius,
            transition: theme.palette.propVars?.easeInOutTransition,
            '& .icon': {
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: getResponsiveSize(35),
              height: getResponsiveSize(14),
            },
            '& .MuiCardContent-root': {
              p: 0,
            },
          },
        },
      },
    },
  },
};
